// Generated by purs version 0.15.15
import * as Ouroboros_Programs_Controllers_DocumentDetailsPrompt from "../Ouroboros.Programs.Controllers.DocumentDetailsPrompt/index.js";
var mkDocumentDetailsPromptEnv = function (input) {
    return {
        loading: input.kernel.loading,
        navigate: input.kernel.navigate,
        reviewRoute: input.kernel.reviewRoute,
        document: input.kernel.document,
        answerDocumentQuestions: input.kernel.answerDocumentQuestions,
        taskRunner: input.kernel.taskRunner
    };
};
var buildDocumentDetailsPromptViewProps = function (input) {
    var controller = Ouroboros_Programs_Controllers_DocumentDetailsPrompt.mkDocumentDetailsPromptController(mkDocumentDetailsPromptEnv(input));
    return {
        documentQuestion: input.documentQuestion,
        onSubmit: function (response) {
            return Ouroboros_Programs_Controllers_DocumentDetailsPrompt.runDocumentDetailsPromptAction(controller.submit(response));
        }
    };
};
export {
    buildDocumentDetailsPromptViewProps
};
//# sourceMappingURL=index.js.map
